import { render, staticRenderFns } from "./InboxEdit.vue?vue&type=template&id=79bc626b"
import script from "./InboxEdit.vue?vue&type=script&lang=js"
export * from "./InboxEdit.vue?vue&type=script&lang=js"
import style0 from "./InboxEdit.vue?vue&type=style&index=0&id=79bc626b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports